function after() {

    // console.log('lifecycle :', 'after loading scene');
}

export {after};
